import { useState } from 'react'
import { useTournaments, useTournamentsHistory } from '@hooks/queries/useTournaments'
import { TOURNAMENT_ORIGIN, TOURNAMENTS_PAGE_SIZE } from '@constants/tournamentConstants'
import TournamentsList from './TournamentsList'
import TournamentCardController from './TournamentCardController'

// One list, parametrized by origin — unlike defenderV2's CurrentTournaments.js
// / TournamentsHistory.js, which duplicated ~90% of this for Current vs
// History. Both queries are declared; only the active one is enabled so
// switching tabs never fires the inactive query.
const TournamentsListTab = ({ origin }) => {
  const [page, setPage] = useState(1)
  const isHistory = origin === TOURNAMENT_ORIGIN.HISTORY

  const activeList = useTournaments(
    { tournamentStatus: 'ACTIVE', page, pageSize: TOURNAMENTS_PAGE_SIZE },
    { enabled: !isHistory }
  )
  const historyList = useTournamentsHistory(
    { page, pageSize: TOURNAMENTS_PAGE_SIZE },
    { enabled: isHistory }
  )

  const { data, isPending, isError } = isHistory ? historyList : activeList
  const rows = data?.rows ?? []

  return (
    <TournamentsList
      rows={rows}
      renderCard={(row) => (
        <TournamentCardController key={row.id} tournament={row} origin={origin} variant="list" />
      )}
      isPending={isPending}
      isError={isError}
      emptyMessage={isHistory ? 'No Tournament History' : 'No Active Tournaments'}
      total={data?.count}
      pageSize={TOURNAMENTS_PAGE_SIZE}
      currentPage={page}
      onPageChange={setPage}
    />
  )
}

export default TournamentsListTab
